import {useEffect, useRef, useState} from "react";

export const useSetState = (initialState = {}) => {
    const [state, regularSetState] = useState(initialState);
    const setState = newState => {
        const key = Object.keys(newState)[0];
        const value = newState[key];
        regularSetState(prevState => {
            return {
                ...prevState,
                [key] : {...prevState[key], ...value
            }
            }
        });

    };

    return [state, setState];
};

export function useIsMountedRef(){
    const isMountedRef = useRef(null);
    useEffect(() => {
        isMountedRef.current = true;
        return () => isMountedRef.current = false;
    });
    return isMountedRef;
}

const useScript = url => {
    // Keep track of script status ("idle", "loading", "ready", "error")
    const [status, setStatus] = useState( url ? "loading" : "idle" );
    useEffect(() => {
        if (!url) {
            setStatus("idle");
            return;
        }
        var ms = new Date().getTime().toString();
        // var seed = "?version=" + ms;
        const script = document.createElement('script');
        new Promise((resolve, reject) => {
            //  script.src = url;
            script.async = true;
            script.setAttribute('src', url);
            script.setAttribute('id', 'DHScript');
            script.setAttribute('type', 'text/javascript');
            script.addEventListener("load", function () {resolve(); });
            script.addEventListener("error", function (e) { reject(e); });
            document.body.appendChild(script);
        }).then(() => {
            setStatus("ready")
        }).catch(() => {
            setStatus("error")
        })
        return () => {
            setStatus("idle");
            document.body.removeChild(script);
            const setStateFromEvent = (event) => { setStatus(event.type === "load" ? "ready" : "error"); };
            script.removeEventListener("load", setStateFromEvent);
            script.removeEventListener("error", setStateFromEvent);
        }
    }, [url]);
    return status
};

export default useScript;